export const ROUTES = {
  SELECTED_CANDIDATES_2025: "/reviewer/campus-hiring/selected-candidates/2025",
  SELECTED_CANDIDATES_2024: "/reviewer/campus-hiring/selected-candidates/2024",
  SELECTED_CANDIDATES_2026: "/reviewer/campus-hiring/selected-candidates/2026",
  SELECTED_CANDIDATES_2027: "/reviewer/campus-hiring/selected-candidates/2027",
  CAMPUS_CANDIDATES: "/reviewer/campus-hiring/candidates/",
  CAMPUS_CANDIDATES_LIVE_STATUS_2025:
    "/reviewer/campus-hiring/candidates/live-status/2025",
  CAMPUS_CANDIDATES_LIVE_STATUS_2026:
    "/reviewer/campus-hiring/candidates/live-status/2026",
  CAMPUS_CANDIDATES_LIVE_STATUS_2027:
    "/reviewer/campus-hiring/candidates/live-status/2027",
};
